import { render, staticRenderFns } from "./ReporteInventarioGeneral.vue?vue&type=template&id=4d2884c8&scoped=true&"
import script from "./ReporteInventarioGeneral.vue?vue&type=script&lang=ts&"
export * from "./ReporteInventarioGeneral.vue?vue&type=script&lang=ts&"
import style0 from "./ReporteInventarioGeneral.vue?vue&type=style&index=0&id=4d2884c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2884c8",
  null
  
)

export default component.exports